// extracted by mini-css-extract-plugin
export default {"header":"ButtonClose_header__F2SR+","button":"ButtonClose_button__mHIti"};